module.exports = "/_next/static/images/OgSegmentIndustryEnterprise-4b4f8e968e969f827dea6cc026a7dd92.png";